// Enterprise CTA Section
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, MessageSquare, Zap } from 'lucide-react';
import { useScrollReveal } from '@/hooks/use-scroll-reveal';

export const EnterpriseCTA = () => {
  const { isVisible, elementRef } = useScrollReveal({ threshold: 0.2 });
  
  return (
    <section 
      ref={elementRef}
      className="relative py-24 lg:py-32 bg-[#0a0a0a] overflow-hidden"
    >
      {/* Background glow */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse 60% 40% at 50% 100%, hsl(var(--primary) / 0.1) 0%, transparent 60%)',
        }}
      />
      
      <div className="container-professional relative z-10">
        <div 
          className="max-w-4xl mx-auto text-center"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
            transition: 'all 0.7s cubic-bezier(0.16, 1, 0.3, 1)',
          }}
        >
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-8">
            <Zap className="w-4 h-4 text-primary" />
            <span className="text-sm font-medium text-primary">Ready to Scale?</span>
          </div>
          
          {/* Headline */}
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            Let's Build Something{' '}
            <span className="text-primary">Exceptional</span>
          </h2>
          
          {/* Description */}
          <p className="text-lg text-white/60 max-w-2xl mx-auto mb-10">
            Start with a free 30-minute discovery call. We'll discuss your challenges, 
            explore possibilities, and determine if we're the right fit.
          </p>
          
          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-xl bg-primary hover:bg-[#00d4e6] text-white font-semibold transition-all duration-300 hover:-translate-y-0.5"
              style={{
                boxShadow: '0 4px 24px -6px hsl(var(--primary) / 0.5)',
              }}
            >
              <Calendar className="w-5 h-5" />
              Schedule Discovery Call
              <ArrowRight className="w-5 h-5" />
            </Link>
            <a
              href="mailto:hello@affinityaim.com"
              className="inline-flex items-center gap-2 px-6 py-4 text-white/70 hover:text-white font-medium transition-colors"
            >
              <MessageSquare className="w-4 h-4" />
              Or email us directly
            </a>
          </div>
          
          {/* Trust note */}
          <p className="mt-10 text-sm text-white/40">
            No sales pressure. No commitment. Just a conversation about what's possible.
          </p>
        </div>
      </div>
    </section>
  );
};
